import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { ModalBack } from '../Modal.Back/Modal.Back.es.js';
import { ModalContext } from '../Modal.Context/Modal.Context.es.js';
import { ModalSubtitle } from '../Modal.Subtitle/Modal.Subtitle.es.js';
import { ModalTitle } from '../Modal.Title/Modal.Title.es.js';

const ModalHeader = ({ title, children, hideBack, variant, iconName, ...props })=>{
    const { disableClose, disableBack } = useContext(ModalContext);
    // If close/back buttons are hidden, or icon is visible, less padding needed
    const narrowPadding = useMemo(()=>disableClose && disableBack || Boolean(variant || iconName), [
        disableBack,
        disableClose,
        iconName,
        variant
    ]);
    return jsxs("div", {
        className: classNames('cb-modal-header', {
            'narrow-padding': narrowPadding
        }),
        "data-testid": "modal-header",
        ...props,
        children: [
            !hideBack && jsx(ModalBack, {}),
            jsx(ModalTitle, {
                iconName: iconName,
                variant: variant,
                children: title
            }),
            children != null && jsx(ModalSubtitle, {
                children: children
            })
        ]
    });
};
ModalHeader.displayName = 'Modal.Header';

export { ModalHeader };
//# sourceMappingURL=Modal.Header.es.js.map
